import { fetcher } from '@commenda/utils';
import type { AdminChargebeeCustomerSummary } from './useAdminCompanyExternalConnections';

export interface SearchAdminChargebeeCustomersParams {
  query: string;
  limit?: number;
}

export async function searchAdminChargebeeCustomers({
  query,
  limit = 10,
}: SearchAdminChargebeeCustomersParams): Promise<
  AdminChargebeeCustomerSummary[]
> {
  const params = new URLSearchParams({
    query,
    limit: String(limit),
  });

  const response = await fetcher(
    `admin/external-connections/chargebee/customers/search?${params.toString()}`,
    { method: 'GET' }
  );

  if (!response.ok) {
    const body = (await response.json().catch(() => null)) as {
      message?: unknown;
      error?: unknown;
    } | null;
    const message =
      typeof body?.message === 'string'
        ? body.message
        : Array.isArray(body?.message)
          ? body.message.join(', ')
          : typeof body?.error === 'string'
            ? body.error
            : 'Failed to search Chargebee customers';
    throw new Error(message);
  }

  return response.json();
}
